import React from "react";

interface ExternoProps {
  className?: string;
  width?: number;
  fill?: string;
  height?: number;
}
const IconExterno: React.FC<ExternoProps> = ({ className, width, height }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 48 48" fill="none">
    <g mask="url(#a)">
      <path
        d="M17 20v11h14V20h-3v6.375q0 .574-.475.863a.95.95 0 0 1-.975.037L24 26l-2.55 1.275a.95.95 0 0 1-.975-.037Q20 26.95 20 26.375V20zm0 13q-.825 0-1.412-.587A1.93 1.93 0 0 1 15 31V18.525q0-.35.113-.675.112-.325.337-.6l1.25-1.525q.275-.35.688-.537T18.25 15h11.5q.45 0 .863.188.412.187.687.537l1.25 1.525q.225.274.338.6.112.325.112.675V31q0 .824-.587 1.413A1.93 1.93 0 0 1 31 33zm.4-15h13.2l-.85-1h-11.5zm4.6 2v4.75l2-1 2 1V20z"
        fill="#C2282B"
      />
    </g>
  </svg>
);
export default IconExterno;
